import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_14eeavl3ro: FaireBrandEntity = {
  token: "b_14eeavl3ro",
  type: "brand",
  name: "Sourcebooks",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b85f110c6d5cdd10867984a02f955ea84b8f6dc6b34fc115b53bfa212421806.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3b8c72ca4f5fe98f4d22b72334b33ee0e5a914e9aed0d07f7d81c78ea3590c31.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b85f110c6d5cdd10867984a02f955ea84b8f6dc6b34fc115b53bfa212421806.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3b8c72ca4f5fe98f4d22b72334b33ee0e5a914e9aed0d07f7d81c78ea3590c31.jpeg",
  location: "Naperville, IL, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 843,
  isTopShop: true,
  isInsider: true,
  description:
    "Sourcebooks believes books change lives. We are committed to providing readers with books that will illuminate, inspire, and enlighten. \n\nAs a team of passionate, energetic and enthusiastic book lovers we are collaborative, adaptive and iterative. We are a top-15 book publisher known for innovation, creative partnerships, unique content and high-impact retail programs. \n\nWe are the home of dozens of New York Times and USA Today bestsellers. Our books are published in nearly every shape, size and format. The eclectic and exciting breadth of our genres include: childrens, historical, commercial and literary fiction, young adult, romance, mystery, journals, regional, personalized and gift books. We also publish popular calendars and planners and our Simple Truths brand of personal development and leadership titles.\n\nJoin us…and thank you for being a part of our story!\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:53.342Z",
    importedBy: "entity-db-cli",
  },
};
